var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-card',{attrs:{"image":_vm.image,"title":_vm.title,"text":_vm.text,"meta":_vm.meta,"link":_vm.link}})}
var staticRenderFns = []

export { render, staticRenderFns }